import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import { Script } from 'gatsby';

const components = {
  a: (props) => {
    const isExternal = props.href && props.href.startsWith('http');
    return (
      <a
        {...props}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
      >
        {props.children}
      </a>
    );
  },
};

export const wrapRootElement = ({ element }) => {
  return (
    <>
      {/* Include the Google Analytics tag */}
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-7426QNMG7G"
      />
      <Script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-7426QNMG7G');
        `}
      </Script>
      <MDXProvider components={components}>{element}</MDXProvider>
    </>
  );
};
